@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (displayModalChange) {
  <p-dialog [(visible)]="displayModalChange" appendTo="body" [style]="{width: '380px'}" [baseZIndex]="10000" [modal]="true" [showHeader]="false" [closable]="false">
    <div style="text-align:center; padding:32px 24px 24px;">
      <div style="width:64px; height:64px; background:#dcfce7; border-radius:50%; display:flex; align-items:center; justify-content:center; margin:0 auto 16px;">
        <span class="pi pi-check" style="font-size:32px; color:#16a34a;"></span>
      </div>
      <div style="font-size:15px; font-weight:600; text-transform:uppercase; letter-spacing:0.08em; color:#6b7280; margin-bottom:8px;">Change Due</div>
      <div style="font-size:74px; font-weight:800; color:#111; line-height:1; margin-bottom:24px; font-variant-numeric:tabular-nums;">{{Change | currency:CurrencySymbol}}</div>
      <div style="display:flex; gap:10px;">
        <button pButton pRipple type="button" class="p-button p-element p-button-success" style="flex:1; height:48px; font-size:17px; font-weight:700;" (click)="closeChangeDialog()">
          Done
        </button>
      </div>
    </div>
  </p-dialog>
}

@if (displayModalServerItems) {
  <p-dialog [(visible)]="displayModalServerItems" appendTo="body" [style]="{width: '480px'}" [baseZIndex]="10000" [modal]="true" [showHeader]="false" [closable]="false">
    <div style="padding:24px 20px 20px;">
      <div style="display:flex; align-items:center; gap:10px; margin-bottom:6px;">
        <span class="pi pi-shopping-bag" style="font-size:24px; color:#2563eb;"></span>
        <div style="font-size:22px; font-weight:800; color:#111;">Items to Serve</div>
      </div>
      <div style="font-size:15px; color:#6b7280; margin-bottom:18px;">These don't go to the kitchen. Tap Complete as you make each one.</div>
      @for (item of serverItemsOutstanding; track item) {
        <div style="display:flex; align-items:center; gap:12px; padding:12px 0; border-bottom:1px solid #f3f4f6;">
          <div style="min-width:44px; height:44px; background:#eff6ff; border-radius:8px; display:flex; align-items:center; justify-content:center; font-size:20px; font-weight:800; color:#2563eb;">
            {{item.qty}}
          </div>
          <div style="flex:1; min-width:0;">
            <div style="font-size:19px; font-weight:700; color:#111;">{{item.name}}</div>
            @if (item.options) {
              <div style="font-size:14px; color:#6b7280;">{{item.options}}</div>
            }
          </div>
          <button pButton pRipple type="button" class="p-button p-element p-button-success" style="height:44px; font-size:16px; font-weight:700;" (click)="completeServerItem(item)">
            <span class="pi pi-check" style="margin-right:6px;"></span>Complete
          </button>
        </div>
      }
      @if (serverItemsOutstanding.length === 0) {
        <div style="padding:18px 0; text-align:center; color:#16a34a; font-size:18px; font-weight:700;">
          <span class="pi pi-check-circle" style="margin-right:8px;"></span>All items done
        </div>
      }
      @if (serverItemsCompleted.length > 0) {
        <div style="margin-top:20px; padding-top:14px; border-top:2px solid #e5e7eb;">
          <div style="font-size:14px; font-weight:700; text-transform:uppercase; letter-spacing:0.06em; color:#6b7280; margin-bottom:8px;">Completed</div>
          @for (item of serverItemsCompleted; track item) {
            <div style="display:flex; align-items:center; gap:12px; padding:8px 0; opacity:0.65;">
              <span class="pi pi-check-circle" style="color:#16a34a; font-size:20px;"></span>
              <div style="flex:1; min-width:0;">
                <div style="font-size:17px; font-weight:600; color:#374151; text-decoration:line-through;">{{item.qty}} &times; {{item.name}}</div>
                @if (item.options) {
                  <div style="font-size:13px; color:#9ca3af;">{{item.options}}</div>
                }
              </div>
              <button pButton pRipple type="button" class="p-button p-element p-button-outlined p-button-secondary" style="height:38px; font-size:15px; font-weight:600;" (click)="undoServerItem(item)">
                <span class="pi pi-undo" style="margin-right:6px;"></span>Undo
              </button>
            </div>
          }
        </div>
      }
      <button pButton pRipple type="button" class="p-button p-element p-button-outlined p-button-secondary" style="width:100%; height:48px; font-size:17px; font-weight:600; margin-top:20px;" (click)="closeServerItems()">
        Close
      </button>
    </div>
  </p-dialog>
}

<p-dialog [(visible)]="awaitingTerminalPayment" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '380px'}">
  <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:32px 24px; text-align:center;">
    <i class="pi pi-spin pi-spinner" style="font-size:3rem; color:#2563eb;"></i>
    <div style="font-size:1.2rem; font-weight:700; color:#111827;">Waiting for Terminal</div>
    <div style="font-size:0.95rem; color:#6b7280;">Please complete the payment on the card reader.</div>
    <button pButton pRipple type="button"
      class="p-button p-button-secondary"
      style="min-width:160px;"
      (click)="cancelTerminalPayment()"><span class="p-button-icon p-button-icon-left pi pi-times" aria-hidden="true"></span><span class="p-button-label">Cancel Payment</span></button>
    </div>
  </p-dialog>

  <p-dialog [(visible)]="showTerminalBusyDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '420px'}">
    <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:28px 24px 8px; text-align:center;">
      <div style="width:60px; height:60px; border-radius:50%; background:#fff7ed; display:flex; align-items:center; justify-content:center;">
        <i class="pi pi-exclamation-triangle" style="font-size:2rem; color:#d97706;"></i>
      </div>
      <div style="font-size:1.2rem; font-weight:700; color:#111827;">Terminal In Use</div>
      <div style="font-size:0.95rem; color:#6b7280; line-height:1.5;">This terminal is currently processing another transaction. Would you like to wait for it to finish, or clear the terminal and retry?</div>
    </div>
    <ng-template #footer>
      <div style="display:flex; justify-content:center; gap:10px; padding-bottom:8px;">
        <button pButton pRipple type="button"
          class="p-button p-button-secondary p-button-outlined"
          style="min-width:120px;"
          (click)="waitForTerminal()"><span class="p-button-icon p-button-icon-left pi pi-clock" aria-hidden="true"></span><span class="p-button-label">Wait</span></button>
          <button pButton pRipple type="button"
            class="p-button p-button-danger"
            style="min-width:150px;"
            (click)="clearTerminalAndRetryPayment()"><span class="p-button-icon p-button-icon-left pi pi-replay" aria-hidden="true"></span><span class="p-button-label">Clear Terminal</span></button>
          </div>
        </ng-template>
      </p-dialog>

      <p-dialog [(visible)]="showPaymentFailedDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '420px'}">
        <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:28px 24px 8px; text-align:center;">
          <div style="width:60px; height:60px; border-radius:50%; background:#fef2f2; display:flex; align-items:center; justify-content:center;">
            <i class="pi pi-times-circle" style="font-size:2rem; color:#dc2626;"></i>
          </div>
          <div style="font-size:1.2rem; font-weight:700; color:#111827;">Payment Failed</div>
          <div style="font-size:0.95rem; color:#6b7280; line-height:1.5;">{{paymentFailedMessage}}</div>
        </div>
        <ng-template #footer>
          <div style="display:flex; justify-content:center; padding-bottom:8px;">
            <button pButton pRipple type="button"
              class="p-button p-button-danger"
              style="min-width:140px;"
              (click)="showPaymentFailedDialog=false; displayModal=true;"><span class="p-button-icon p-button-icon-left pi pi-refresh" aria-hidden="true"></span><span class="p-button-label">Try Again</span></button>
            </div>
          </ng-template>
        </p-dialog>

        <p-dialog header="Whoops" [(visible)]="displayModalOverPaymentWarning" [style]="{width: '50vw'}" [baseZIndex]="10000"  [modal]="true">
          <p style="font-size: 17px;width: 100%;text-align: center;">You cannot pay more than the value of the sale on a Card.</p>
          <ng-template #footer>
            <p-button icon="pi pi-check" (click)="displayModalOverPaymentWarning=false" label="OK" styleClass="p-button-text"></p-button>
          </ng-template>
        </p-dialog>


        @if (AccessAllowed && !DataLoaded) {
          <div class="surface-card p-4 shadow-2 border-round" style="height: calc(100vh - 154px); display:flex; align-items:center; justify-content:center; flex-direction:column; gap:16px;">
            <p-progressbar mode="indeterminate" [style]="{'width': '300px', 'height': '6px'}"></p-progressbar>
            <span style="color:#6b7280; font-size:16px;">Loading till data…</span>
          </div>
        }

        @if (AccessAllowed && DataLoaded) {
          <div
            class="surface-card p-3 shadow-2 border-round"
            [style.height]="openTabs.length > 0 ? 'calc(100vh - 274px)' : 'calc(100vh - 154px)'"
            style="display:flex; flex-direction:column; overflow:hidden; box-sizing:border-box;">
            <!-- Cash drawer message. Our own element rather than a toast: it is removed by *ngIf
            and the box itself is click-through, so it can never be left over the page. -->
            @if (drawerService.showNotice) {
              <div
                style="position:fixed; top:80px; right:24px; z-index:9000; max-width:380px; pointer-events:none; display:flex; align-items:flex-start; gap:10px; padding:12px 14px; border-radius:8px; box-shadow:0 4px 14px rgba(0,0,0,0.18);"
                [style.background]="drawerService.noticeSeverity === 'error' ? '#fef2f2' : (drawerService.noticeSeverity === 'warn' ? '#fffbeb' : '#f0fdf4')"
                [style.border]="'1px solid ' + (drawerService.noticeSeverity === 'error' ? '#fecaca' : (drawerService.noticeSeverity === 'warn' ? '#fde68a' : '#bbf7d0'))">
                <span class="pi"
                  [ngClass]="drawerService.noticeSeverity === 'error' ? 'pi-times-circle' : (drawerService.noticeSeverity === 'warn' ? 'pi-exclamation-triangle' : 'pi-check-circle')"
                  [style.color]="drawerService.noticeSeverity === 'error' ? '#dc2626' : (drawerService.noticeSeverity === 'warn' ? '#d97706' : '#16a34a')"
                style="font-size:18px; margin-top:1px;"></span>
                <div style="flex:1; min-width:0;">
                  <div style="font-size:15px; font-weight:700; color:#111; margin-bottom:2px;">{{drawerService.noticeSummary}}</div>
                  <div style="font-size:13px; color:#4b5563; line-height:1.45;">{{drawerService.noticeDetail}}</div>
                </div>
                <button (click)="drawerService.dismissNotice()"
                  aria-label="Dismiss message"
                  style="pointer-events:auto; width:24px; height:24px; flex-shrink:0; display:flex; align-items:center; justify-content:center; border:none; border-radius:4px; background:transparent; color:#6b7280; cursor:pointer;">
                  <span class="pi pi-times" style="font-size:12px;"></span>
                </button>
              </div>
            }
            <!-- Magic number band: stays until dismissed -->
            @if (showMagicNumber) {
              <div
                style="display:flex; align-items:center; gap:10px; flex-shrink:0; margin-bottom:8px; padding:6px 12px; background:#eff6ff; border:1px solid #bfdbfe; border-radius:6px;">
                <span class="pi pi-hashtag" style="font-size:14px; color:#2563eb;"></span>
                <span style="font-size:14px; color:#1e3a8a;">
                  Receipt Magic Number: <strong style="font-size:16px; letter-spacing:0.04em;">{{magicNumber}}</strong>
                </span>
                <button (click)="dismissMagicNumber()"
                  aria-label="Dismiss receipt magic number"
                  style="margin-left:auto; width:26px; height:26px; display:flex; align-items:center; justify-content:center; border:none; border-radius:4px; background:transparent; color:#1e3a8a; cursor:pointer; -webkit-tap-highlight-color:transparent;">
                  <span class="pi pi-times" style="font-size:13px;"></span>
                </button>
              </div>
            }
            <!-- Kiosk toolbar -->
            <div style="display:flex; justify-content:flex-end; align-items:center; flex-shrink:0; margin-bottom:8px; gap:8px;">
              <!-- DRAWER KICKING SWITCHED OFF (22/10/26) - the Web Bluetooth drawer is not used for now; the
              receipt printer's driver opens the drawer when a receipt prints. Kept for a later rework.
              <div style="display:flex; align-items:center; gap:8px; margin-right:auto; padding:0 4px; font-size:14px; font-weight:600; color:#6b7280;">
                <span style="width:10px; height:10px; border-radius:50%; display:inline-block;"
                [style.background]="drawerService.connected ? '#16a34a' : '#dc2626'"></span>
                Drawer {{drawerService.connected ? 'Connected' : 'Disconnected'}}
                <button *ngIf="!drawerService.connected"
                  (click)="connectDrawer()"
                  [disabled]="drawerService.busy"
                  style="height:28px; padding:0 10px; border:1px solid #e5e7eb; border-radius:6px; background:#fff; color:#2563eb; font-size:13px; font-weight:700; cursor:pointer; -webkit-tap-highlight-color:transparent;">
                  {{drawerService.busy ? 'Connecting…' : 'Connect'}}
                </button>
              </div>
              -->
              <!-- Receipt printing, on or off for this till only. -->
              <div style="display:flex; align-items:center; gap:8px; margin-right:auto; padding:0 4px; font-size:14px; font-weight:600; color:#6b7280;">
                <span style="width:10px; height:10px; border-radius:50%; display:inline-block;"
                [style.background]="printReceipts ? '#16a34a' : '#9ca3af'"></span>
                Receipts {{printReceipts ? 'On' : 'Off'}}
                <button (click)="togglePrintReceipts()"
                  style="height:28px; padding:0 10px; border:1px solid #e5e7eb; border-radius:6px; background:#fff; color:#2563eb; font-size:13px; font-weight:700; cursor:pointer; -webkit-tap-highlight-color:transparent;">
                  {{printReceipts ? 'Turn Off' : 'Turn On'}}
                </button>
                @if (printReceipts) {
                  <button
                    (click)="printTestReceipt()"
                    style="height:28px; padding:0 10px; border:1px solid #e5e7eb; border-radius:6px; background:#fff; color:#6b7280; font-size:13px; font-weight:700; cursor:pointer; -webkit-tap-highlight-color:transparent;">
                    Test Print
                  </button>
                }
              </div>
              <button (click)="goToTransactions()"
                style="height:36px; padding:0 14px; border:1px solid #e5e7eb; border-radius:8px; background:#fff; color:#6b7280; font-size:14px; font-weight:600; cursor:pointer; display:flex; align-items:center; gap:6px; -webkit-tap-highlight-color:transparent;">
                <span class="pi pi-list" style="font-size:13px;"></span> Transactions
              </button>
              <button (click)="exitTill()"
                style="height:36px; padding:0 14px; border:1px solid #e5e7eb; border-radius:8px; background:#fff; color:#6b7280; font-size:14px; font-weight:600; cursor:pointer; display:flex; align-items:center; gap:6px; -webkit-tap-highlight-color:transparent;">
                <span class="pi pi-sign-out" style="font-size:13px;"></span> Exit Till
              </button>
            </div>
            <!-- Department buttons -->
            <div class="dept-scroll" style="display:flex; flex-wrap:nowrap; gap:8px; flex-shrink:0; padding-bottom:10px; overflow-x:auto; -webkit-overflow-scrolling:touch; scrollbar-width:none; -ms-overflow-style:none;">
              @for (dept of Departments; track dept; let i = $index) {
                <button
                  class="dept-btn"
                  (click)="selectDept(i)"
                  [style.background]="selectedIndex === i ? (dept.colour || '#2563eb') : '#f3f4f6'"
                  [style.color]="selectedIndex === i ? '#fff' : '#374151'"
                  [style.boxShadow]="selectedIndex === i ? '0 2px 8px rgba(0,0,0,0.25)' : '0 1px 3px rgba(0,0,0,0.1)'"
                  style="padding:0 20px; height:54px; border:none; border-radius:10px; font-size:17px; font-weight:700; cursor:pointer; white-space:nowrap; flex-shrink:0; transition:all 0.15s;">
                  {{dept.name}}
                </button>
              }
            </div>
            <!-- Content: products + till roll -->
            <div class="surface-card p-3 shadow-2 border-round" style="flex:1; min-height:0; overflow:hidden; display:flex; gap:16px;">
              <!-- Products grid -->
              <div style="flex:1; min-width:0; overflow-y:auto; overflow-x:hidden; display:grid; grid-template-columns:repeat(auto-fill, minmax(160px, 1fr)); align-content:flex-start; gap:10px; padding-right:4px;">
                @for (product of deptProducts; track product) {
                  <button
                    type="button"
                    class="till-product-btn"
                    (click)="addProduct(product)"
                    [style.backgroundColor]="product.colour"
                    style="padding:8px 12px; border:none; border-radius:8px; width:100%; color:white; height:110px; cursor:pointer; font-size:20px; font-weight:600; overflow:hidden; text-overflow:ellipsis; box-shadow:0 2px 4px rgba(0,0,0,0.15); word-break:break-word;">
                    {{product.name}}
                  </button>
                }
              </div>
              <!-- Right column: till roll + pay -->
              <div style="width:360px; flex-shrink:0; display:flex; flex-direction:column; gap:8px;">
                <div class="surface-card shadow-2 border-round overflow-hidden" style="flex:1; min-height:0; display:flex; flex-direction:column;">
                  <!-- Header row -->
                  <div style="display:flex; align-items:center; padding:8px 12px; background:#f3f4f6; border-bottom:2px solid #e5e7eb; flex-shrink:0;">
                    <div style="flex:1; font-size:15px; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.05em;">Item</div>
                    <div style="width:40px; text-align:center; font-size:15px; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.05em;">Qty</div>
                    <div style="width:85px; text-align:right; font-size:15px; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.05em;">Price</div>
                    <div style="width:52px; flex-shrink:0;"></div>
                  </div>
                  <!-- Items list -->
                  <div style="flex:1; overflow-y:auto; overflow-x:hidden;">
                    @for (tillprods of tillRole; track tillprods; let last = $last) {
                      <!-- Row: tap to expand -->
                      <div (click)="toggleExpand(tillprods)"
                        style="display:flex; align-items:center; padding:10px 12px; cursor:pointer; user-select:none;"
                        [style.background]="expandedItem === tillprods ? '#eff6ff' : ''"
                        [style.border-bottom]="expandedItem === tillprods ? '1px solid #bfdbfe' : (last ? 'none' : '1px solid #f3f4f6')">
                        <div style="flex:1; min-width:0;">
                          <div style="font-weight:600; font-size:20px; color:#111;">{{tillprods.product.name}}</div>
                          @for (opt of tillprods.selectedOptions; track opt) {
                            <div style="font-size:15px; color:#6b7280; padding-left:6px; line-height:1.6;">
                              <span style="color:#9ca3af;">+</span> {{opt.name}}@if (opt.price > 0) {
                              <span style="color:#059669;"> (+{{opt.price | currency:CurrencySymbol}})</span>
                            }
                          </div>
                        }
                      </div>
                      <div style="width:40px; text-align:center; flex-shrink:0; font-size:17px; font-weight:600; color:#374151;">{{tillprods.qty}}</div>
                      <div style="width:85px; text-align:right; flex-shrink:0; font-size:17px; font-weight:600; color:#111;">{{tillprods.price | currency:CurrencySymbol}}</div>
                      <div style="width:52px; flex-shrink:0; display:flex; align-items:center; justify-content:center;">
                        <div [style.background]="expandedItem === tillprods ? '#bfdbfe' : '#f3f4f6'"
                          [style.color]="expandedItem === tillprods ? '#2563eb' : '#9ca3af'"
                          style="width:44px; height:44px; border-radius:50%; display:flex; align-items:center; justify-content:center;">
                          <span class="pi pi-pencil" style="font-size:17px;"></span>
                        </div>
                      </div>
                    </div>
                  }
                  <!-- Empty state -->
                  @if (tillRole.length === 0) {
                    <div style="padding:24px 12px; text-align:center; color:#9ca3af; font-size:17px;">
                      No items added
                    </div>
                  }
                </div>
                <!-- Total -->
                <div style="border-top:2px solid #e5e7eb; padding:10px 12px; background:#f9fafb; flex-shrink:0; display:flex; align-items:center; justify-content:space-between;">
                  <span style="font-size:17px; font-weight:700; color:#374151;">Total</span>
                  <div style="display:flex; align-items:center; gap:10px;">
                    <button (click)="showNotesDialog=true"
                      [disabled]="tillRole.length === 0"
                      [style.opacity]="tillRole.length === 0 ? '0.35' : '1'"
                      [style.background]="orderNotes ? '#fef3c7' : 'transparent'"
                      [style.color]="orderNotes ? '#d97706' : '#9ca3af'"
                      [style.borderColor]="orderNotes ? '#fcd34d' : '#e5e7eb'"
                      style="border:1px solid; border-radius:6px; cursor:pointer; padding:4px 10px; display:flex; align-items:center; gap:5px; font-size:14px; font-weight:600;">
                      <span class="pi pi-comment" style="font-size:14px;"></span>
                      {{ orderNotes ? 'Edit Notes' : 'Notes' }}
                    </button>
                    <span style="font-size:21px; font-weight:800; color:#111;">{{TillRoleTotal | currency:CurrencySymbol}}</span>
                  </div>
                </div>
                <!-- Outstanding (shown when sale has existing payments) -->
                @if (existingPaidTotal > 0 && outstandingTotal > 0) {
                  <div style="padding:4px 12px 6px; background:#f0fdf4; border-top:1px solid #bbf7d0; flex-shrink:0; display:flex; flex-direction:column; gap:2px;">
                    <div style="display:flex; justify-content:space-between; align-items:center;">
                      <span style="font-size:13px; color:#16a34a; font-weight:600;">Already paid</span>
                      <span style="font-size:13px; color:#16a34a; font-weight:600;">−{{existingPaidTotal | currency:CurrencySymbol}}</span>
                    </div>
                    <div style="display:flex; justify-content:space-between; align-items:center;">
                      <span style="font-size:15px; font-weight:700; color:#374151;">Outstanding</span>
                      <span style="font-size:17px; font-weight:800; color:#111;">{{outstandingTotal | currency:CurrencySymbol}}</span>
                    </div>
                  </div>
                }
                <!-- Update Tab / Cancel buttons -->
                @if (activeTabSaleId && tillRole.length > 0) {
                  <div style="padding:8px 12px; flex-shrink:0; border-top:1px solid #e5e7eb; display:flex; gap:6px;">
                    <button pButton pRipple type="button"
                      class="p-button p-element p-button-warn"
                      style="flex:1; height:52px; font-size:18px; font-weight:700;"
                      (click)="updateTab()">
                      <span class="pi pi-save" style="margin-right:8px;"></span>Update Tab
                    </button>
                    <button pButton pRipple type="button"
                      class="p-button p-element p-button-danger"
                      style="height:52px; font-size:18px; font-weight:700; padding:0 16px;"
                      title="Cancel editing this tab and start a new order"
                      (click)="cancelTabEdit()">
                      <span class="pi pi-times"></span>
                    </button>
                  </div>
                }
              </div>
              <!-- Pay button -->
              <button pButton pRipple type="button"
                class="p-button p-element p-button-success"
                style="width:100%; height:56px; font-size:18px; font-weight:700; flex-shrink:0;"
                (click)="initPay();">
                <span class="pi pi-pound" style="margin-right:8px;"></span>PAY
              </button>
              <!-- No Sale button -->
              <button pButton pRipple type="button"
                class="p-button p-element p-button-secondary p-button-outlined"
                style="width:100%; height:40px; font-size:14px; font-weight:600; flex-shrink:0; margin-top:6px;"
                (click)="noSale();">
                <span class="pi pi-inbox" style="margin-right:8px;"></span>No Sale
              </button>
            </div>
          </div>
        </div>
      }

      <p-dialog [(visible)]="showTillNamePrompt" [modal]="true" [style]="{width: '360px'}" [draggable]="false" [resizable]="false" [showHeader]="false" [closable]="false">
        <div style="padding:24px;">
          <div style="text-align:center; margin-bottom:20px;">
            <div style="width:56px; height:56px; background:#fef3c7; border-radius:50%; display:flex; align-items:center; justify-content:center; margin:0 auto 12px;">
              <span class="pi pi-desktop" style="font-size:28px; color:#d97706;"></span>
            </div>
            <div style="font-size:18px; font-weight:700; color:#111; margin-bottom:4px;">Name This Till</div>
            <div style="font-size:15px; color:#6b7280;">Enter a name for this device (e.g. Bar, Front Desk). This is saved locally and only applies to this computer.</div>
          </div>
          <div style="margin-bottom:20px;">
            <label style="font-size:15px; font-weight:600; color:#374151; display:block; margin-bottom:6px;">Till Name</label>
            <input pInputText [(ngModel)]="tillNameInput" placeholder="e.g. Bar, Front Desk, Reception" style="width:100%;" (keyup.enter)="confirmTillName()" autofocus />
          </div>
          <button pButton pRipple type="button" class="p-button p-element p-button-success" style="width:100%; height:44px; font-weight:700;" (click)="confirmTillName()">
            <span class="pi pi-check" style="margin-right:6px;"></span>Save &amp; Continue
          </button>
        </div>
      </p-dialog>

      <p-dialog [(visible)]="showTillNumberDialog" [modal]="true" [style]="{width: '360px'}" [draggable]="false" [resizable]="false" [showHeader]="false" [closable]="false">
        <div style="padding:24px;">
          <div style="text-align:center; margin-bottom:20px;">
            <div style="width:56px; height:56px; background:#fef3c7; border-radius:50%; display:flex; align-items:center; justify-content:center; margin:0 auto 12px;">
              <span class="pi pi-send" style="font-size:28px; color:#d97706;"></span>
            </div>
            <div style="font-size:18px; font-weight:700; color:#111; margin-bottom:4px;">Kitchen Order</div>
            <div style="font-size:15px; color:#6b7280;">This order contains kitchen items. Please enter a table number.</div>
          </div>
          <div style="margin-bottom:20px;">
            <label style="font-size:15px; font-weight:600; color:#374151; display:block; margin-bottom:6px;">Table Number</label>
            <input pInputText [(ngModel)]="tillNumber" placeholder="e.g. 1, 2, A..." style="width:100%; text-align:center; font-size:23px; font-weight:700;" (keyup.enter)="confirmTillNumber()" autofocus />
          </div>
          <div style="display:flex; gap:8px;">
            <button pButton pRipple type="button" class="p-button p-element p-button-success" style="flex:1; height:44px; font-weight:700;" (click)="confirmTillNumber()">
              <span class="pi pi-check" style="margin-right:6px;"></span>Continue
            </button>
            <button pButton pRipple type="button" class="p-button p-element p-button-secondary p-button-outlined" style="flex:1; height:44px;" (click)="showTillNumberDialog=false">
              <span class="pi pi-times" style="margin-right:6px;"></span>Cancel
            </button>
          </div>
        </div>
      </p-dialog>

      <p-dialog [(visible)]="displayModal" [modal]="true" [style]="{width: '480px'}" [draggable]="false" [resizable]="false" [showHeader]="false" [closable]="false">
        <div style="padding:0;">

          <!-- Header band -->
          <div style="background:#f0fdf4; border-bottom:2px solid #bbf7d0; padding:20px 24px; margin:-1px -1px 0 -1px; border-radius:6px 6px 0 0; text-align:center;">
            <div style="font-size:14px; font-weight:600; text-transform:uppercase; letter-spacing:0.08em; color:#16a34a; margin-bottom:4px;">Total to Pay</div>
            <div style="font-size:55px; font-weight:800; color:#111; line-height:1; font-variant-numeric:tabular-nums;">{{TotalCost | currency:CurrencySymbol}}</div>
          </div>

          <div style="padding:20px 24px; display:flex; flex-direction:column; gap:20px;">

            <!-- Amount input -->
            <div style="display:flex; align-items:center; gap:12px;">
              <label style="font-size:15px; font-weight:600; color:#374151; white-space:nowrap;">Amount</label>
              <p-inputnumber [(ngModel)]="TotalCost" inputId="tillPaymentAmount" mode="currency" currency="{{CurrencySymbol}}" [style]="{'width':'100%'}"></p-inputnumber>
            </div>

            <!-- Quick cash buttons -->
            <div>
              <div style="font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.08em; color:#9ca3af; margin-bottom:8px;">Quick Cash</div>
              <div style="display:flex; gap:8px;">
                <button (click)="payOff(5, cashPaymentType)" [disabled]="!cashPaymentType" pButton pRipple type="button" class="p-button p-element p-button-outlined" style="flex:1; height:64px; font-size:20px; font-weight:700;">{{5 | currency:CurrencySymbol:'symbol':'1.0-0'}}</button>
                <button (click)="payOff(10, cashPaymentType)" [disabled]="!cashPaymentType" pButton pRipple type="button" class="p-button p-element p-button-outlined" style="flex:1; height:64px; font-size:20px; font-weight:700;">{{10 | currency:CurrencySymbol:'symbol':'1.0-0'}}</button>
                <button (click)="payOff(20, cashPaymentType)" [disabled]="!cashPaymentType" pButton pRipple type="button" class="p-button p-element p-button-outlined" style="flex:1; height:64px; font-size:20px; font-weight:700;">{{20 | currency:CurrencySymbol:'symbol':'1.0-0'}}</button>
                <button (click)="payOff(50, cashPaymentType)" [disabled]="!cashPaymentType" pButton pRipple type="button" class="p-button p-element p-button-outlined" style="flex:1; height:64px; font-size:20px; font-weight:700;">{{50 | currency:CurrencySymbol:'symbol':'1.0-0'}}</button>
              </div>
            </div>

            <!-- Discount / Voucher -->
            <div style="border:1px solid #e5e7eb; border-radius:8px; overflow:hidden;">

              <!-- Toggle bar -->
              <div style="display:flex; border-bottom:1px solid #e5e7eb;">
                <button type="button"
                  (click)="showDiscountSection=!showDiscountSection; showVoucherSection=false"
                  style="flex:1; padding:9px 12px; border:none; background:{{showDiscountSection ? '#eff6ff' : '#f9fafb'}}; font-size:14px; font-weight:600; color:{{showDiscountSection ? '#2563eb' : '#6b7280'}}; cursor:pointer; border-right:1px solid #e5e7eb;">
                  <span class="pi pi-tag" style="margin-right:6px;"></span>Discount Code
                </button>
                <button type="button"
                  (click)="showVoucherSection=!showVoucherSection; showDiscountSection=false"
                  style="flex:1; padding:9px 12px; border:none; background:{{showVoucherSection ? '#eff6ff' : '#f9fafb'}}; font-size:14px; font-weight:600; color:{{showVoucherSection ? '#2563eb' : '#6b7280'}}; cursor:pointer;">
                  <span class="pi pi-gift" style="margin-right:6px;"></span>Gift Voucher
                </button>
              </div>

              <!-- Discount panel -->
              @if (showDiscountSection) {
                <div style="padding:14px; display:flex; flex-direction:column; gap:10px; background:#fff;">
                  <p-selectbutton [options]="discountModeOptions" [(ngModel)]="discountMode" optionLabel="label" optionValue="value" [style]="{'width':'100%'}"></p-selectbutton>
                  @if (discountMode === 'code') {
                    <div style="display:flex; gap:8px;">
                      <input pInputText [(ngModel)]="discountCode" placeholder="Enter discount code" style="flex:1; text-transform:uppercase;" (keyup.enter)="applyDiscount()" />
                      <button pButton pRipple type="button" class="p-button p-element p-button-primary" style="white-space:nowrap;" (click)="applyDiscount()">Apply</button>
                    </div>
                  }
                  @if (discountMode === 'open') {
                    <div style="display:flex; gap:8px; align-items:center;">
                      <p-inputnumber [(ngModel)]="openDiscountAmount" mode="currency" currency="{{CurrencySymbol}}" [max]="TotalCost" [style]="{'flex':'1'}"></p-inputnumber>
                      <button pButton pRipple type="button" class="p-button p-element p-button-primary" style="white-space:nowrap;" (click)="applyDiscount()">Apply</button>
                    </div>
                  }
                </div>
              }

              <!-- Voucher panel -->
              @if (showVoucherSection) {
                <div style="padding:14px; display:flex; flex-direction:column; gap:10px; background:#fff;">
                  <div style="display:flex; gap:8px;">
                    <input pInputText [(ngModel)]="voucherCode" placeholder="Voucher code" style="flex:2; text-transform:uppercase;" />
                    <input pInputText [(ngModel)]="voucherPin" placeholder="PIN" maxlength="4" type="password" inputmode="numeric" style="flex:1;" (keyup.enter)="applyVoucher()" />
                    <button pButton pRipple type="button" class="p-button p-element p-button-primary" style="white-space:nowrap;" (click)="applyVoucher()">Apply</button>
                  </div>
                </div>
              }

              <!-- Applied discount summary -->
              @if (appliedDiscountTotal > 0) {
                <div style="padding:8px 14px; background:#f0fdf4; border-top:1px solid #bbf7d0; display:flex; justify-content:space-between; align-items:center; font-size:15px;">
                  <span style="color:#16a34a; font-weight:600;"><span class="pi pi-check-circle" style="margin-right:6px;"></span>Discount applied</span>
                  <span style="color:#16a34a; font-weight:700;">-{{appliedDiscountTotal | currency:CurrencySymbol}}</span>
                </div>
              }
            </div>

            <!-- Pay buttons -->
            <div>
              <div style="font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.08em; color:#9ca3af; margin-bottom:8px;">Pay With</div>
              <div style="display:flex; flex-wrap:wrap; gap:8px;">
                @for (pt of PaymentTypes; track pt) {
                  <button (click)="payOff(TotalCost, pt)" pButton pRipple type="button" class="p-button p-element p-button-success" style="flex:1; height:56px; font-size:17px; font-weight:700; min-width:120px;">
                    <span class="pi" [ngClass]="getPaymentIcon(pt.name)" style="margin-right:8px;"></span>{{pt.name}}
                  </button>
                }
              </div>
            </div>

            <!-- Void + On Tab + Cancel -->
            <div style="display:flex; gap:8px; padding-top:4px; border-top:1px solid #f3f4f6;">
              <button pButton pRipple type="button" class="p-button p-element p-button-danger p-button-outlined" style="flex:1; height:40px; font-size:15px;" (click)="requestVoid()">
                <span class="pi pi-ban" style="margin-right:6px;"></span>Void
              </button>
              <button pButton pRipple type="button" class="p-button p-element p-button-warn p-button-outlined" style="flex:1; height:40px; font-size:15px;" (click)="openTabDialog()">
                <span class="pi pi-bookmark" style="margin-right:6px;"></span>On Tab
              </button>
              <button pButton pRipple type="button" class="p-button p-element p-button-secondary p-button-outlined" style="flex:1; height:40px; font-size:15px;" (click)="cancelPay()">
                <span class="pi pi-times" style="margin-right:6px;"></span>Cancel
              </button>
            </div>

          </div>
        </div>
      </p-dialog>

      <p-dialog header="Void Transaction" [(visible)]="showVoidConfirm" [modal]="true" [style]="{width:'380px'}" [draggable]="false" [resizable]="false">
        <div style="display:flex; align-items:flex-start; gap:12px; padding:8px 0;">
          <span class="pi pi-exclamation-triangle" style="font-size:28px; color:#dc2626; flex-shrink:0; margin-top:2px;"></span>
          <span style="font-size:17px; line-height:1.5;">Are you sure you want to void this transaction? This cannot be undone.</span>
        </div>
        <ng-template #footer>
          <button pButton pRipple type="button" class="p-button p-element p-button-danger" (click)="confirmVoid()">
            <span class="pi pi-ban" style="margin-right:6px;"></span>Yes, Void
          </button>
          <button pButton pRipple type="button" class="p-button p-element p-button-secondary p-button-outlined" style="margin-left:8px;" (click)="cancelVoid()">
            <span class="pi pi-arrow-left" style="margin-right:6px;"></span>Go Back
          </button>
        </ng-template>
      </p-dialog>

      <p-dialog [header]="'Options for ' + (pendingProduct?.name ?? '')"
        [(visible)]="showOptionsDialog"
        [modal]="true"
        [style]="{width: '420px'}"
        [draggable]="false"
        [resizable]="false">

        @for (opt of pendingProduct?.options; track opt) {
          <label style="display:flex; justify-content:space-between; align-items:center; padding:10px 0; border-bottom:1px solid #e5e7eb; cursor:pointer; user-select:none;">
            <div style="display:flex; align-items:center; gap:10px;">
              <p-checkbox [value]="opt" [(ngModel)]="selectedOptions" [binary]="false"></p-checkbox>
              <span style="font-size:17px;">{{opt.name}}</span>
            </div>
            @if (opt.price > 0) {
              <span style="color:#374151; font-weight:600;">+{{opt.price | currency:CurrencySymbol}}</span>
            }
            @if (opt.price === 0) {
              <span style="color:#9ca3af; font-size:15px;">Free</span>
            }
          </label>
        }

        <ng-template #footer>
          <button pButton pRipple type="button" class="p-button p-element p-button-success" (click)="confirmAddWithOptions()">
            <span [class]="editingTillRollItem ? 'pi pi-check' : 'pi pi-plus'" style="margin-right:6px;"></span>
            {{editingTillRollItem ? 'Update Options' : 'Add to Order'}}
          </button>
          <button pButton pRipple type="button" class="p-button p-element p-button-danger" style="margin-left:8px;" (click)="cancelOptionsDialog()">
            <span class="pi pi-times" style="margin-right:6px;"></span>Cancel
          </button>
        </ng-template>
      </p-dialog>

      <p-dialog header="Order Notes" [(visible)]="showNotesDialog" [modal]="true" [style]="{width:'420px'}" [draggable]="false" [resizable]="false">
        <textarea pTextarea [(ngModel)]="orderNotes" rows="10"
          placeholder="Add notes for this order..."
          autofocus
          style="width:100%; font-size:17px; resize:none;">
        </textarea>
        <ng-template #footer>
          <button pButton pRipple type="button" class="p-button p-element p-button-success" (click)="showNotesDialog=false">
            <span class="pi pi-check" style="margin-right:6px;"></span>Done
          </button>
        </ng-template>
      </p-dialog>


      <p-dialog header="Put Order On Tab" [(visible)]="showTabNameDialog" [modal]="true" [style]="{width: '380px'}" [draggable]="false" [resizable]="false" [closable]="false">
        <div style="padding:8px 0;">
          <label style="font-size:15px; font-weight:600; color:#374151; display:block; margin-bottom:6px;">Tab Name</label>
          <input pInputText [(ngModel)]="tabName" placeholder="Enter a name for this tab..." style="width:100%;" (keyup.enter)="confirmPutOnTab()" autofocus />
        </div>
        <ng-template #footer>
          <button pButton pRipple type="button" class="p-button p-element p-button-warn" (click)="confirmPutOnTab()">
            <span class="pi pi-bookmark" style="margin-right:6px;"></span>Put on Tab
          </button>
          <button pButton pRipple type="button" class="p-button p-element p-button-secondary p-button-outlined" style="margin-left:8px;" (click)="cancelTabDialog()">
            <span class="pi pi-times" style="margin-right:6px;"></span>Cancel
          </button>
        </ng-template>
      </p-dialog>

      @if (AccessAllowed && DataLoaded && openTabs.length > 0) {
        <div style="margin-top:12px;">
          <div class="surface-card p-3 shadow-2 border-round">
            <div style="font-size:14px; font-weight:700; text-transform:uppercase; letter-spacing:0.06em; color:#6b7280; margin-bottom:10px;">
              <span class="pi pi-bookmark" style="margin-right:6px;"></span>Open Tabs
            </div>
            <div style="display:flex; flex-wrap:wrap; gap:10px;">
              @for (tab of openTabs; track tab) {
                <button
                  pButton pRipple type="button"
                  class="p-button p-element p-button-warn"
                  [class.p-button-outlined]="tab.tillsaleid !== activeTabSaleId"
                  style="height:60px; padding:0 20px; font-weight:600; font-size:18px;"
                  (click)="loadTab(tab)">
                  <span class="pi pi-user" style="margin-right:8px;"></span>
                  {{tab.tabname}} &mdash; {{tab.total | currency:CurrencySymbol}}
                </button>
              }
            </div>
          </div>
        </div>
      }

      <!-- Item edit bottom sheet -->
      @if (expandedItem) {
        <div
          style="position:fixed; inset:0; z-index:2000;"
          (click)="expandedItem = null">
          <div style="position:absolute; inset:0; background:rgba(0,0,0,0.45);"></div>
          <div class="item-sheet"
            (click)="$event.stopPropagation()"
            style="position:absolute; bottom:0; left:0; right:0; background:#fff; border-radius:20px 20px 0 0; padding:20px 24px 36px; box-shadow:0 -4px 24px rgba(0,0,0,0.2);">
            <div style="width:40px; height:4px; background:#d1d5db; border-radius:2px; margin:0 auto 20px;"></div>
            <div style="margin-bottom:20px;">
              <div style="font-size:22px; font-weight:700; color:#111;">{{expandedItem.product.name}}</div>
              @for (opt of expandedItem.selectedOptions; track opt) {
                <div style="font-size:15px; color:#6b7280; margin-top:2px;">
                  + {{opt.name}}@if (opt.price > 0) {
                  <span> (+{{opt.price | currency:CurrencySymbol}})</span>
                }
              </div>
            }
            <div style="font-size:19px; font-weight:600; color:#374151; margin-top:8px;">{{expandedItem.price | currency:CurrencySymbol}}</div>
          </div>
          <div style="display:flex; align-items:center; gap:16px; margin-bottom:20px;">
            <button (click)="changeQty(expandedItem, -1, $event)"
              style="width:64px; height:64px; border:none; border-radius:12px; background:#f3f4f6; color:#374151; font-size:36px; font-weight:700; cursor:pointer; display:flex; align-items:center; justify-content:center; box-shadow:0 2px 4px rgba(0,0,0,0.1);">
              −
            </button>
            <div style="flex:1; text-align:center; font-size:36px; font-weight:800; color:#111;">{{expandedItem.qty}}</div>
            <button (click)="changeQty(expandedItem, 1, $event)"
              style="width:64px; height:64px; border:none; border-radius:12px; background:#f3f4f6; color:#374151; font-size:36px; font-weight:700; cursor:pointer; display:flex; align-items:center; justify-content:center; box-shadow:0 2px 4px rgba(0,0,0,0.1);">
              +
            </button>
          </div>
          <div style="display:flex; gap:10px;">
            @if (expandedItem.product?.options?.length > 0) {
              <button
                (click)="editTillRollOptions(expandedItem); $event.stopPropagation()"
                style="flex:1; height:56px; border:none; border-radius:10px; background:#dbeafe; color:#2563eb; font-size:17px; font-weight:600; cursor:pointer; display:flex; align-items:center; justify-content:center; gap:8px;">
                <span class="pi pi-sliders-h" style="font-size:18px;"></span> Options
              </button>
            }
            <button (click)="removeTillItem(expandedItem); $event.stopPropagation()"
              style="flex:1; height:56px; border:none; border-radius:10px; background:#fee2e2; color:#dc2626; font-size:17px; font-weight:600; cursor:pointer; display:flex; align-items:center; justify-content:center; gap:8px;">
              <span class="pi pi-trash" style="font-size:18px;"></span> Remove
            </button>
            <button (click)="expandedItem = null; $event.stopPropagation()"
              style="width:56px; height:56px; border:none; border-radius:10px; background:#f3f4f6; color:#6b7280; cursor:pointer; display:flex; align-items:center; justify-content:center;">
              <span class="pi pi-times" style="font-size:20px;"></span>
            </button>
          </div>
        </div>
      </div>
    }

    <p-dialog header="Administrator Approval Required" [(visible)]="showAdminOverride" [modal]="true" [style]="{width:'420px'}" [draggable]="false" [resizable]="false" [closable]="false">
      <div style="display:flex; align-items:flex-start; gap:12px; padding:8px 0 16px;">
        <span class="pi pi-shield" style="font-size:28px; color:#d97706; flex-shrink:0; margin-top:2px;"></span>
        <span style="font-size:15px; line-height:1.5; color:#374151;">This action requires approval from a Venue Administrator. Select an administrator and enter their PIN to continue.</span>
      </div>
      <div style="display:flex; flex-direction:column; gap:12px;">
        <div>
          <label style="font-size:14px; font-weight:600; color:#374151; display:block; margin-bottom:6px;">Administrator</label>
          <p-select
            [options]="adminOverrideUsers"
            [(ngModel)]="adminOverrideSelectedId"
            optionLabel="name"
            optionValue="userid"
            placeholder="Select administrator..."
            [style]="{width:'100%'}">
          </p-select>
        </div>
        <div>
          <label style="font-size:14px; font-weight:600; color:#374151; display:block; margin-bottom:6px;">PIN</label>
          <input pInputText type="password" [(ngModel)]="adminOverridePin" placeholder="Enter PIN" style="width:100%;" (keyup.enter)="submitAdminOverride()" />
        </div>
      </div>
      <ng-template #footer>
        <button pButton pRipple type="button" class="p-button p-element p-button-warn" (click)="submitAdminOverride()">
          <span class="pi pi-check-circle" style="margin-right:6px;"></span>Authorise
        </button>
        <button pButton pRipple type="button" class="p-button p-element p-button-secondary p-button-outlined" style="margin-left:8px;" (click)="cancelAdminOverride()">
          <span class="pi pi-times" style="margin-right:6px;"></span>Cancel
        </button>
      </ng-template>
    </p-dialog>
